import { render, staticRenderFns } from "./SingleDomino.vue?vue&type=template&id=35ac3102&"
import script from "./SingleDomino.vue?vue&type=script&lang=js&"
export * from "./SingleDomino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports